import { Box } from "@mui/material";
import React from "react";
import { Container } from "react-bootstrap";
const logo = "/gainss-logo.png";

const HeadingWithText = ({ heading, text }) => {
  return (
    <p>
      <strong>{heading}</strong> - {text}
    </p>
  );
};

export const Privacy = () => {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
          marginTop: "0.4rem",
          p: 2
        }}
        onClick={() => {
          window.location = "/";
        }}
      >
        <img src={logo} width="125" alt="GAINSS" />
      </Box>
      <Container className="py-5">

        <div>
          <h2>GAINSS Privacy Notice</h2>
          <p>
            <strong>Effective Date:</strong> Jan 1, 2024
          </p>
          <p>
            <strong>Last Updated:</strong> August 8, 2024
          </p>
          <p>
            This Privacy Notice (the “Notice”) applies to personal information
            collected by, or provided to, GTEN Technologies, and/or its
            affiliates and subsidiaries (collectively "GTEN Technologies”, "we",
            “us", “our") via the websites, applications, and electronic
            communications from which it is linked (collectively, the
            “Platform”). This Notice describes how GTEN Technologies uses the
            personal information that it collects, receives, maintains, and
            stores about you. This Notice does not apply to Customer Data (as
            defined in the GTEN Technologies Terms of Use) processed, stored, or
            hosted by our customers using GTEN Technologies’ products and
            services. Our customers are responsible for deciding how Customer
            Data is used, so please see their applicable privacy notice for more
            information.
          </p>
          <h4>1. Types of personal information Collected</h4>
          <p>
            We may collect personal information from or about you in order to
            provide, enhance, market, and offer our products and services
            offered via the Platform, and to otherwise communicate with you.
            This section describes the categories of personal information we may
            collect, including personal information we have collected in the
            past twelve months. You are not required to give us all the personal
            information identified in this Notice; however, if you do not
            provide requested personal information, we may not be able to
            provide you with some or all of our services.
          </p>
          <HeadingWithText
            heading="Contact and Demographic Information"
            text="-name; address (including billing and shipping
        address); telephone number; email address; and fax number."
          />
          <HeadingWithText
            heading=" Payment Information"
            text="If you make a purchase, we will collect your payment information
      including your credit card information and billing address, together with your purchase
      details."
          />
          <HeadingWithText
            heading="Account Information"
            text="We may also collect user ID and password, and screen name."
          />
          <HeadingWithText
            heading="Location Data"
            text="While navigating the Platform, your mobile device or browser may share
      your location data, both through WiFi and GPS, and IP address or MAC address. We will
      collect this information based on the settings of your phone and browser."
          />
          <HeadingWithText
            heading="Usage Information"
            text="We may also collect usage and device information when you visit the
      Platform. This may include information relating to your Internet activity or other electronic
      network activity, which includes device information; web server type and version; PHP
      version; database type and version; cookie information; device information; browsing
      activities, and platform or mobile application use data; referring domain; destination domain
      and destination path; performance, security, software configuration and availability of our
      software on your servers and network; website user statistics and website and portal use and
      viewing activity records; and communication preferences."
          />
          <HeadingWithText
            heading="Education and Employment Information"
            text="If you apply for employment with GTEN
      Technologies, we will collect your employment and work history, as well as personal
      information related to your potential employment. This may include, but is not limited to,
      your education and employment history, address and contact information, demographic
      information, and the contents of your resume."
          />
          <HeadingWithText
            heading="Communication Information"
            text="We may collect audio, electronic, or visual information, which includes screen sharing views; any data in any files uploaded, emailed or otherwise provided by customers; the contents of your communications with GTEN Technologies, whether via email, social media, telephone or otherwise; and inferences we may make from other personal information we collect."
          />
          <h4>2. Method of Information Collection</h4>
          <p>
            We collect personal information in a variety of ways. We collect
            personal information directly from you; for example, when you visit
            our websites, respond to a survey, participate in a telephone
            interaction, fill out a registration form or otherwise use our
            software, or communicate with us through one of our websites to
            receive information about our business to business services or to
            schedule a demonstration of our products or programs, and if you
            expressed interest in being contacted by us at a trade show in which
            we participated or hosted.
          </p>
          <p>
            {" "}
            We may also collect personal information from third parties. For
            example, we may collect personal information from service providers
            that help us to build and maintain our contact lists, which
            integrate their services into ours, or in other ways work with us
            for our mutual benefit.
          </p>
          <p>
            {" "}
            We also collect personal information from you passively. For
            example, our Platform uses tracking tools like cookies, pixels, and
            web beacons to collect usage and browser information. For more
            information about the trackers that we use, please see Section 6 of
            this Notice. Additionally, if you enable location data on your
            device, this data will be collected based on the location settings
            on your device.
          </p>
          <h4>3. Combining Personal Information</h4>
          <p>
            We may combine personal information we obtain. For example, we may
            combine personal information that we have collected online with
            personal information that we have collected offline, for instance
            during calls between you and our support team. We may also combine
            personal information that we have collected across other third party
            sites or from other third parties with personal information we
            already have.
          </p>
          <h4>4. How We Use Personal Information</h4>
          To the extent permitted by applicable law, we may use personal
          information to:
          <ul>
            <li>
              Operate our Platform and provide support to our business
              functions;
            </li>
            <li>
              Fulfil customer requests, such as to create a GTEN Technologies
              account or complete customer purchases;
            </li>
            <li>
              Protect against criminal activity, claims, and other liabilities;
            </li>
            <li>
              Send customers information regarding GTEN Technologies, our
              Platform, and our products and services;
            </li>
            <li>
              Respond to reviews, comments, or other feedback provided to us;
            </li>
            <li>
              Support and personalize our Platform, products and services,
              websites, mobile services, and advertising;
            </li>
            <li>
              Protect the security and integrity of our Platform, content, and
              our business;
            </li>
            <li>Provide customer support;</li>
            <li>
              The extent required for benchmarking, data analysis, audits,
              developing new products, enhancing our Platform, facilitating
              product, software and applications development, improving our
              services, conducting research, analysis, studies or surveys,
              identifying usage trends, as well as for other analytics purposes;
            </li>
            <li>Meet our contractual requirements;</li>
            <li>
              Comply with applicable legal or regulatory requirements and our
              policies;
            </li>
            <li>
              Communicate with our customers, including to provide them with
              information about our products, programs, services and promotions;
            </li>
            <li>Market, advertise, and provide our Platform;</li>
            <li>
              The extent necessary for any other lawful purpose for which the
              personal information is collected.
            </li>
          </ul>
          <h4>5. Sharing personal information</h4>
          We may share your personal information in the following circumstances:
          <ul>
            <li>
              <strong>Within GTEN Technologies:</strong> We may share your
              personal information within our family of companies.
            </li>
            <li>
              <strong>Service Providers:</strong> When we hire a service
              provider to help operate the Platform or our business, we may
              allow access to personal information as necessary to perform the
              service for us. This may include service providers that operate
              our Platform, send our communications, or run our promotions.
            </li>
            <li>
              <strong>Business Partners:</strong> We may share personal
              information with our trusted business partners. For example, we
              may share your personal information with a company when we
              co-sponsor a promotion or service. These partners may use your
              personal information to, among other things, send you information
              or contact you about their services and products.
            </li>
            <li>
              <strong>Third Parties for Marketing Purposes:</strong> To the
              extent permitted by applicable law, we may share personal
              information with third parties for purposes of our marketing,
              advertising, promotions, contests, or other similar purposes.
            </li>
            <li>
              <strong>Legal Obligation or Protection from Harm:</strong> When we
              have a good faith belief that access, use, preservation, or
              disclosure of the personal information is reasonably necessary to
              (a) satisfy or comply with any requirement of law, regulation,
              legal process, or enforceable governmental request, (b) enforce or
              investigate a potential violation of the Terms of Use, (c) detect,
              prevent, or otherwise respond to fraud, security, or technical
              concerns, (d) support auditing and compliance functions, or (e)
              protect the rights, property, or safety of GTEN Technologies, its
              users, or the public against harm.
            </li>
            <li>
              <strong>Mergers, Acquisitions, Divestitures:</strong> If we are
              involved in a merger, acquisition, or any form of transfer or sale
              of some or all of our business, whether as a going concern or as
              part of bankruptcy, liquidation, or similar proceeding, personal
              information may be transferred along with the business. Where
              legally required we will give you prior notice and, if you have a
              legal right to do so, an opportunity to object to this transfer.
            </li>
            <li>
              <strong>Purposes described to you:</strong> We may share your
              personal information for other purposes, as we describe to you and
              as permitted by applicable law.
            </li>
          </ul>
          <h4>6. Cookies and Other Technologies</h4>
          <p>
            We collect information about users over time on the Platform by
            using several common types of cookies and other tracking
            technologies including log files, pixel tags, web bugs, web beacons,
            clear GIFs, Local Storage Objects (LSOs) such as HTML5 and Flash or
            other similar technologies to collect information about the ways you
            interact with and use the GTEN Technologies Platform, to support and
            enhance features and functionality, to monitor performance, to
            personalize content and experiences, for marketing and analytics,
            and for other lawful purposes. We may also permit third parties that
            collect information in this way on our behalf and for their own
            purposes. Cookies are small files that download when you access
            certain websites. For more information about cookies visit:{" "}
            <a
              href="http://www.allaboutcookies.org/"
              target="_blank"
              rel="noreferrer"
            >
              http://www.allaboutcookies.org/
            </a>
            .
          </p>
          <p>
            To assist us with analysing our website traffic through cookies and
            similar technologies, we use analytics services such as Google
            Analytics. For more information on Google Analytics’ processing of
            your information, please see “How Google uses data when you use our
            partners' Platforms or apps.” You can opt-out of Google Analytics by
            installing Google’s opt-out browser add-on.
          </p>
          <p>
            These cookies may be placed by us (first-party) or by a third party.
            These cookies may also be Flash Cookies. To learn how to manage
            privacy and storage settings for Flash cookies{" "}
            <a
              href="https://www.adobe.com/devnet/security.html"
              target="_blank"
              rel="noreferrer"
            >
              click here
            </a>
            . We may use cookies that are session-based or persistent. Session
            cookies expire when you close your browser or turn off your device.
            Persistent cookies remain on your device after you close your
            browser or turn off your device.
          </p>
          <p>We may use a variety of cookies:</p>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Type of Cookies</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Required</strong>
                </td>
                <td>
                  Required cookies are essential for the operation of GTEN
                  Technologies Products and Services. They include, for example,
                  cookies that allow you to access secure areas of the Platform
                  and using our services.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Performance</strong>
                </td>
                <td>
                  These cookies collect information about how you use the GTEN
                  Technologies Products and Services, including which pages you
                  go to most often and if they receive error messages from
                  certain pages. The information collected via these cookies is
                  only used to improve how the Platform functions and performs.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Functionality</strong>
                </td>
                <td>
                  Functionality cookies allow the Platform to remember
                  information you have entered or choices you make (such as your
                  username, language, or your region) and provide enhanced, more
                  personal features. These cookies also enable you to optimize
                  your use of the Platform after logging in. These cookies can
                  also be used to remember changes you have made to text size,
                  fonts, and other parts of web pages that you can customize.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Targeting or Advertising</strong>
                </td>
                <td>
                  From time to time, we may engage third parties to track and
                  analyze usage and volume statistical information from
                  individuals who visit the Platform. We sometimes use cookies
                  delivered by third parties to track the performance of our
                  advertisements. For example, these cookies remember which
                  browsers have visited the Platform. The information provided
                  to third parties does not include Personal Data, but this
                  information may be re-associated with Personal Data after we
                  receive it. By way of example, as you visit the Platform,
                  advertising cookies may be placed on your computer so that we
                  can understand what you are interested in. Our advertising
                  partners then enable us to present you with retargeted
                  advertising on other sites based on your previous interaction
                  with the Platform.
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            Third parties, with whom we partner to provide certain features on
            the Platform or to display advertising based upon your web browsing
            activity, use Flash cookies to collect and store information. Flash
            cookies are different from browser cookies because of the amount of,
            type of, and how data is stored.
          </p>
          <p>
            Most internet browsers accept cookies by default. You can accept or
            block cookies by activating the setting on your browser that allows
            you to reject all or some cookies. You may also be able to change
            your cookie preferences via the Platform. The help and support area
            on your internet browser should have instructions on how to block or
            delete cookies. Some web browsers (including some mobile web
            browsers) provide settings that allow you to control or reject
            cookies or to alert you to when a cookie is placed on your computer,
            tablet, or mobile device. Although you are not required to accept
            cookies, if you block or reject them, you may not have access to all
            of the features available through the GTEN Technologies Products and
            Services.
          </p>
          <ul>
            <li>
              <a
                href="https://support.microsoft.com/en-us/help/278835/how-to-delete-cookie-files-in-internet-explorer"
                target="_blank"
                rel="noreferrer"
              >
                Cookie settings in Internet Explorer
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                target="_blank"
                rel="noreferrer"
              >
                Cookie settings in Firefox
              </a>
            </li>
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647?hl=en"
                target="_blank"
                rel="noreferrer"
              >
                Cookie settings in Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/en-us/HT201265"
                target="_blank"
                rel="noreferrer"
              >
                Cookie settings in Safari web and iOS
              </a>
            </li>
          </ul>
          <p>
            To find out more on how to manage and delete cookies, visit{" "}
            <a href="http://aboutcookies.org/" target="_blank" rel="noreferrer">
              aboutcookies.org
            </a>
            . For more details on your choices regarding the use of your web
            browsing activity for interest-based advertising, you may visit the
            following sites:
          </p>
          <ul>
            <li>
              <a
                href="http://networkadvertising.org/"
                target="_blank"
                rel="noreferrer"
              >
                networkadvertising.org
              </a>
            </li>
            <li>
              <a
                href="http://optout.aboutads.info/"
                target="_blank"
                rel="noreferrer"
              >
                optout.aboutads.info
              </a>
            </li>
            <li>
              <a
                href="http://youradchoices.com/"
                target="_blank"
                rel="noreferrer"
              >
                youradchoices.com
              </a>
            </li>
            <li>
              <a
                href="http://youronlinechoices.eu/"
                target="_blank"
                rel="noreferrer"
              >
                youronlinechoices.eu
              </a>
            </li>
          </ul>
          <p>
            On a mobile device, you may also be able to adjust your settings to
            permit or limit ad tracking.
          </p>
          <h4>7. Children Under the Age of 13</h4>
          The Platform is meant for adults and we will not knowingly collect
          personal information from any person under the age of 13 without
          permission from a parent or guardian. The Platform is not designed to
          attract the attention of persons under the age of 13. If you are a
          parent or legal guardian and think your child has given us information
          you can email us at
          <a href="privacy@gtentechnologies.com">
            privacy@gtentechnologies.com
          </a>
          . You can also write to us at the address listed in the “Contact Us”
          section of this Notice. Please mark your inquiries “COPPA Inquiry.”
          <h4>8. Your Choices</h4>
          <p>
            Depending on where you are located, you may have certain choices
            about how we use your personal information, including the right to
            access, receive a copy of, correct, delete, and opt- out of the
            processing of, your Personal Data. To exercise your rights
            (including to opt-out of marketing communications) please email us
            at privacy@gtentechnologies.com or by following the instructions
            included in the email or text correspondence. Please note that, even
            if you unsubscribe from certain correspondence, we may still need to
            contact you with important transactional or administrative
            information, as permitted by law. Additionally, if you withdraw your
            consent or object to processing, or if you choose not to provide
            certain personal information, we may be unable to provide some or
            all of the services to you.
          </p>
          <h4>9. California Privacy Rights</h4>
          <p>
            Pursuant to California’s Shine the Light statute (Cal. Civ. Code §
            1798.83), you can control if we share personal information with
            third parties for their marketing purposes. To opt-out of us sharing
            your personal information with third parties for such purposes,
            email us at{" "}
            <a href="mailto:privacy@gtentechnologies.com">
              privacy@gtentechnologies.com
            </a>{" "}
            and include “Marketing Opt-Out” in your request.
          </p>
          <p>
            In addition, pursuant to the California Consumer Privacy Act of 2018
            (“CCPA”), California residents may have certain other rights
            concerning their personal information. This section describes (i)
            the categories of personal information collected and disclosed by
            GTEN Technologies, subject to CCPA, (ii) your privacy rights under
            CCPA, and (iii) how to exercise those rights.
          </p>
          <p>
            When we use the term “personal information” in this section, we mean
            information that identifies, relates to, describes, is capable of
            being associated with, or could reasonably be linked, directly or
            indirectly, with a particular consumer or household.
          </p>
          <h3>a. Personal Information We Collect.</h3>
          <p>
            During the past twelve (12) months we and our service providers have
            collected the categories of personal information set forth below. We
            may disclose each of these categories of personal information to our
            service providers for our business purposes (to enable the service
            providers to provide their services) and as otherwise described in
            the “How We Disclose Personal Information” section above. We will
            not collect additional categories of personal information or use
            personal information collected for additional purposes without
            providing you notice.
          </p>
          <ul>
            <li>
              <strong>Identifiers:</strong> (for example, name, postal address,
              date of birth, email address, IP address, and online identifiers)
            </li>
            <li>
              <strong>Categories of personal information:</strong> as defined by
              Cal. Civ. Code § 1798.80 (for example, name, signature, Taxpayer
              Identification Number, telephone number, passport number, driver’s
              license number, insurance policy number, account numbers)
            </li>
            <li>
              <strong>Protected classifications:</strong> under California or
              federal law (for example, age, citizenship status, national origin
              or ancestry)
            </li>
            <li>
              <strong>Commercial information:</strong> (for example, transaction
              history)
            </li>
            <li>
              <strong>
                Internet or other electronic network activity information:
              </strong>{" "}
              including information on your usage of our Sites
            </li>
            <li>
              <strong>Geolocation data</strong>
            </li>
            <li>
              <strong>Sensory data:</strong> (for example, audio from call
              recordings)
            </li>
            <li>
              <strong>Employment-related information</strong>
            </li>
            <li>
              <strong>Inferences drawn:</strong> from any information identified
              above to create a profile
            </li>
          </ul>
          <h3>b. Your Privacy Rights.</h3>
          <p>
            In accordance with the CCPA, California residents may exercise,
            under certain conditions, the following privacy rights with respect
            to their personal information. Please note: you will not be
            discriminated against in any way if you exercise the rights listed
            below, which means we will not deny goods or services to you,
            provide different prices or rates for goods or services to you, or
            provide a different level or quality of goods or services to you.
          </p>
          <table>
            <thead>
              <tr>
                <th>Privacy Right</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Notice</strong>
                </td>
                <td>
                  You may have the right to be notified, at or before the point
                  of collection, of the categories of personal information we
                  collect and the purposes for which they will be used and
                  shared.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Access</strong>
                </td>
                <td>
                  You may have the right to request the categories of personal
                  information that we collected in the previous twelve (12)
                  months, the categories of sources from which the personal
                  information was collected, the specific pieces of personal
                  information we have collected about you, and the business
                  purposes for which such personal information is collected and
                  shared. You may also have the right to request the categories
                  of personal information which were disclosed for business
                  purposes, and the categories of third parties in the twelve
                  (12) months preceding your request for your personal
                  information.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Data Portability</strong>
                </td>
                <td>
                  You may have the right to receive a portable copy of the
                  personal information you have previously provided to us.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Erasure</strong>
                </td>
                <td>
                  You may have the right to ask us to delete (and have us direct
                  our service providers to delete) your personal information.
                  However, please be aware that we may not fulfill your request
                  for deletion if we (or our service provider(s)) are required
                  or permitted to retain your personal information for one or
                  more of the following categories of purposes: (1) to complete
                  a transaction for which the personal information was
                  collected, provide a good or service requested by you, or
                  complete a contract between us and you; (2) to ensure our
                  website integrity, security, and functionality; (3) to comply
                  with applicable law or a legal obligation, or exercise rights
                  under the law (including free speech rights); or (4) to
                  otherwise use your personal information, internally, in a
                  lawful manner that is compatible with the context in which you
                  provided the information.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>To Opt-Out</strong>
                </td>
                <td>
                  We do not sell your personal information. If in the future we
                  do sell your personal information, we will notify you and you
                  may have the right to opt-out of such sale.
                </td>
              </tr>
            </tbody>
          </table>
          <h3>c. How to Exercise Your Rights.</h3>
          <p>
            If you would like to exercise your rights listed above, please send
            (or have your authorized agent send) an email to{" "}
            <a href="mailto:privacy@gtentechnologies.com">
              privacy@gtentechnologies.com
            </a>
            .
          </p>
          <h3>d. How We Respond to Your Requests.</h3>
          <p>
            In all cases, we will respond to your request within 45 days.
            However, where reasonably necessary, we may extend our response time
            by an additional 45 days, provided we send you notice of such
            extension first. We will provide the information to you via your
            preferred delivery mechanism. If the information is provided to you
            electronically, we will provide you the information in a portable
            format and, to the extent technically feasible, in a
            machine-readable, readily usable format that allows you to freely
            transmit this information without hindrance.
          </p>
          <p>
            Please note that we will not charge you for making a request,
            provided that you make no more than two (2) requests per year. If
            you make three (3) or more requests in any given twelve (12) month
            period, we may refuse to respond to such requests if determined by
            us to be unfounded or excessive (e.g. repetitive in nature), or we
            may charge a reasonable fee taking into account the administrative
            costs of providing the information or communication or taking the
            action requested. If we refuse to act on the request, we will
            provide you notice and the reason for our refusal to act.
          </p>
          <h4>10. Information for Individuals in the EU and UK</h4>
          <p>
            In accordance with European and UK law (collectively, the “GDPR”),
            individuals in the EU and/or UK may have additional rights relating
            to the collection and processing of personal information.
          </p>
          <h3>a. Basis for Processing</h3>
          <p>
            Our legal basis for processing the personal information described in
            this Notice will depend on the personal information concerned and
            the context in which we process it. We process personal information
            from you:
          </p>
          <ul>
            <li>where we need it to perform a contract with you;</li>
            <li>
              where the processing is in our legitimate interests (including the
              purposes described, above, in How We Use personal information);
            </li>
            <li>
              where the processing is necessary for us to meet our applicable
              legal obligations; or
            </li>
            <li>if we otherwise have your consent.</li>
          </ul>
          <h3>b. Your Privacy Rights</h3>
          <p>Depending on applicable law, you may have the right to:</p>
          <ul>
            <li>Request access to your personal information.</li>
            <li>Request correction of your personal information.</li>
            <li>
              Request erasure of your personal information. Note, however, that
              we may not always be able to comply with your request of erasure
              for specific legal reasons which will be notified to you, if
              applicable, at the time of your request.
            </li>
            <li>Object to processing of your personal information.</li>
            <li>
              Request restriction of processing of your personal information.
            </li>
            <li>
              Request the transfer of your personal information to you or to a
              third party.
            </li>
            <li>
              Withdraw consent at any time where we are relying on consent to
              process your personal information.
            </li>
          </ul>
          <p>
            If you wish to exercise any of these rights or would like further
            information please contact us at{" "}
            <a href="mailto:privacy@gtentechnologies.com">
              privacy@gtentechnologies.com
            </a>
            . Depending on the nature of your request, we may need to verify
            your identity.
          </p>
          <p>
            Depending on where you are located, you may have a right to lodge a
            complaint with a supervisory authority or other regulatory agency if
            you believe that we have violated any of the rights concerning
            personal information. We encourage you to first reach out to us at{" "}
            <a href="mailto:privacy@gtentechnologies.com">
              privacy@gtentechnologies.com
            </a>{" "}
            or using the address in the “Contact Us” section below, so we have
            an opportunity to address your concerns directly before you do so.
          </p>
          <h4>11. Storage, Security and Retention of Information</h4>
          <p>
            {" "}
            We take reasonable steps to protect the personal information users
            share with us, including, but not limited to, setup of processes,
            equipment and software to avoid unauthorized access or disclosure of
            this information. No transmission of information via the Internet
            can be entirely secure, however, so please always use caution when
            submitting personal information. We will retain your personal
            information in compliance with the uses described in this Notice, as
            well as to comply with our legal, financial reporting, or compliance
            obligations.
          </p>
          <h4>12. Transfers of Personal Information</h4>
          <p>
            We process and store personal information both inside the United
            States and overseas. If you live outside of the United States, be
            advised that we may transfer your personal information to the United
            States and other countries, whose laws may not provide the same
            protections as the laws in your country. Personal information
            transferred outside of the European Economic Area will be subject to
            the appropriate safeguards pursuant to GDPR and other applicable
            law, including without limitation, standard contractual clauses
            approved by the European Commission.
          </p>
          <h4>13. Data Privacy Framework</h4>
          <p>
            GTEN Technologies complies with the EU-U.S. Data Privacy Framework
            (EU-U.S. DPF), the UK Extension to the EU-U.S. DPF, and the
            Swiss-U.S. Data Privacy Framework (Swiss-U.S. DPF) as set forth by
            the U.S. Department of Commerce. GTEN Technologies has certified to
            the U.S. Department of Commerce that it adheres to the EU-U.S. Data
            Privacy Framework Principles (EU-U.S. DPF Principles) with regard to
            the processing of personal data received from the European Union in
            reliance on the EU-U.S. DPF and from the United Kingdom (and
            Gibraltar) in reliance on the UK Extension to the EU-U.S. DPF. GTEN
            Technologies has certified to the U.S. Department of Commerce that
            it adheres to the Swiss-U.S. Data Privacy Framework Principles
            (Swiss-U.S. DPF Principles) with regard to the processing of
            personal data received from Switzerland in reliance on the
            Swiss-U.S. DPF. If there is any conflict between the terms in this
            privacy policy and the EU-U.S. DPF Principles and/or the Swiss-U.S.
            DPF Principles, the Principles shall govern. To learn more about the
            Data Privacy Framework (DPF) program, and to view our certification,
            please visit{" "}
            <a href="https://www.dataprivacyframework.gov/">
              https://www.dataprivacyframework.gov/
            </a>
            . The Federal Trade Commission has jurisdiction over GTEN
            Technologies’ compliance with the EU-U.S. Data Privacy Framework
            (EU-U.S. DPF) and the UK Extension to the EU-U.S. DPF, and the
            Swiss-U.S. Data Privacy Framework (Swiss-U.S. DPF).
          </p>
          <p>
            In compliance with the EU-U.S. DPF and the UK Extension to the
            EU-U.S. DPF and the Swiss-U.S. DPF, GTEN Technologies commits to
            resolve DPF Principles-related complaints about our collection and
            use of your personal information. EU and UK and Swiss individuals
            with inquiries or complaints regarding our handling of personal data
            received in reliance on the EU-U.S. DPF and the UK Extension to the
            EU-U.S. DPF and the Swiss-U.S. DPF should first contact GTEN
            Technologies at:
          </p>
          <p>
            <strong>
              Legal Department
              <br />
              GTEN Technologies
              <br />
              <a href="mailto:privacy@gtentechnologies.com">
                privacy@gtentechnologies.com
              </a>
            </strong>
          </p>
          <p>
            In compliance with the EU-U.S. DPF and the UK Extension to the
            EU-U.S. DPF and the Swiss-U.S. DPF, GTEN Technologies commits to
            refer unresolved complaints concerning our handling of personal data
            received in reliance on the EU-U.S. DPF and the UK Extension to the
            EU-U.S. DPF and the Swiss-U.S. DPF to JAMS, an alternative dispute
            resolution provider based in the United States. If you do not
            receive timely acknowledgment of your DPF Principles-related
            complaint from us, or if we have not addressed your DPF
            Principles-related complaint to your satisfaction, please visit{" "}
            <a href="https://www.jamsadr.com/DPF-Dispute-Resolution">
              https://www.jamsadr.com/DPF-Dispute-Resolution
            </a>{" "}
            for more information or to file a complaint. The services of JAMS
            are provided at no cost to you. If you have a complaint that we have
            violated the DPF Principles that has not been resolved by other
            means, you may have the ability to invoke binding arbitration as
            outlined more fully at{" "}
            <a href="https://www.dataprivacyframework.gov/">
              https://www.dataprivacyframework.gov/
            </a>
            .
          </p>
          <p>
            We may be required to disclose personal data in response to lawful
            requests by public authorities, including to meet national security
            or law enforcement requirements.
          </p>
          <p>
            If we transfer your personal data onward to a third party, we will
            continue to remain liable under the DPF Principles if the
            information is processed in a manner inconsistent with the DPF
            Principles.
          </p>
          <h4>14. Links to Third Parties and their Sites</h4>
          Our Platform may include third party content and links to third party
          websites and services that collect personal information. We do not
          control these third parties and this Notice does not apply to their
          privacy practices. We are not responsible for the practices of these
          third parties or how they use information you provide to them. Please
          read the third parties’ privacy policies carefully.
          <h4>15. Contacting GTEN Technologies</h4>
          <p>
            If you have any questions about this Notice or the privacy practices
            of GTEN Technologies, please email us at{" "}
            <a href="mailto:privacy@gtentechnologies.com">
              privacy@gtentechnologies.com
            </a>
            .
          </p>
          <p>
            If you are contacting us to exercise your rights with respect to
            your personal information as detailed in this Notice, we ask you to
            please adhere to the following guidelines:
          </p>
          <ul>
            <li>
              <strong>Tell Us Which Right You Are Exercising:</strong> Specify
              which right you want to exercise and the personal information to
              which your request relates (if not to you). If you are acting on
              behalf of another consumer, please clearly indicate this fact and
              your authority to act on such consumer’s behalf.
            </li>
            <li>
              <strong>Help Us Verify Your Identity:</strong> Provide us enough
              information to verify your identity. For example, provide us (at a
              minimum) your full name, address, and phone number. Please note
              that if we cannot initially verify your identity, we may request
              additional information to complete the verification process. Any
              personal information you disclose to us for purposes of verifying
              your identity will solely be used for the purpose of verification.
            </li>
            <li>
              <strong>Direct Our Response Delivery:</strong> Inform us of the
              delivery mechanism with which you prefer to receive our response.
              You may specify, for example, email, mail, or through your account
              (if you have one with us).
            </li>
          </ul>
          <p>
            Please note that you do not need to create an account with us in
            order to make a request to exercise your rights hereunder.
          </p>
          <h4>16. Updates</h4>
          <p>
            This Notice may be amended from time-to-time. Unless otherwise
            indicated, any changes to this Notice will apply immediately upon
            posting to the Platform so please check our site periodically for
            updates. You can see when this Notice was last updated by reviewing
            the “Last Updated” legend at the top of this page. We will provide
            notice of material changes by updating the Notice here, and
            communicating with you in the manner and format in which we
            typically communicate with you in our regular course of business, as
            required by applicable law.
          </p>
        </div>
      </Container>
    </div>
  );
};
